import { features } from '@/mocks/movies';

export default function FeaturesSection() {
  return (
    <section className="py-12 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
            为什么选择星空影院
          </h2>
          <p className="text-sm text-foreground-500 mt-2">四大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/50 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}